import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface OrganizationState {
	selectedOrganizationUserId: string | null;
}

const initialState: OrganizationState = {
	selectedOrganizationUserId: null,
};

const organizationSlice = createSlice({
	name: 'organization',
	initialState,
	reducers: {
		setSelectedOrganizationUserId: (state, action: PayloadAction<string | null>) => {
			state.selectedOrganizationUserId = action.payload;
		},
	},
});

export const { setSelectedOrganizationUserId } = organizationSlice.actions;
export const Organization = organizationSlice.reducer;
